import { BaseChallenge } from './challenges/base-challenge';
import { FrameAnalyzer } from './detectors/frame-analyzer';
import type { ChallengeResult, FrameResult } from './types';

export interface ValidatorOptions {
  challenge: BaseChallenge;
  frameAnalyzer: FrameAnalyzer;
  onResult: (result: ChallengeResult) => void;
  onProgress?: (progress: number) => void;
}

export class Validator {
  private challenge: BaseChallenge;

  private frameAnalyzer: FrameAnalyzer;

  private onResult: (result: ChallengeResult) => void;

  private onProgress?: (progress: number) => void;

  private timeoutId: ReturnType<typeof setTimeout> | null = null;

  private isActive = false;

  private originalOnFrame: ((result: FrameResult) => void) | null = null;

  constructor(options: ValidatorOptions) {
    this.challenge = options.challenge;
    this.frameAnalyzer = options.frameAnalyzer;
    this.onResult = options.onResult;
    this.onProgress = options.onProgress;

    this.challenge.onPass = (result: ChallengeResult) => {
      this.stop();
      this.onResult(result);
    };

    this.challenge.onFail = (result: ChallengeResult) => {
      this.stop();
      this.onResult(result);
    };

    this.challenge.onTimeout = (result: ChallengeResult) => {
      this.stop();
      this.onResult(result);
    };

    this.challenge.onProgress = (progress: number) => {
      if (this.onProgress) {
        this.onProgress(progress);
      }
    };
  }

  validateFrame(frame: FrameResult): void {
    if (this.isActive) {
      this.challenge.validateFrame(frame);
    }
  }

  start(timeoutMs = 15000): void {
    if (this.isActive) return;

    this.isActive = true;

    this.challenge.start(timeoutMs);

    this.timeoutId = setTimeout(() => {
      this.stop();
    }, timeoutMs + 1000);
  }

  stop(): void {
    if (!this.isActive) return;

    this.isActive = false;

    if (this.timeoutId !== null) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }
}
